import { Injectable, inject } from '@angular/core';

import { DialogBoxService } from 'app/core/services/dialog-box/dialog-box.service';
import { FormStateService } from 'app/core/services/form-state.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { SavedChangeFormComponent } from './saved-change-form.component';

@Injectable()
export class SavedChangeGuard {
  protected _formStateService = inject(FormStateService);

  private _dialogBoxService = inject(DialogBoxService);
  private dialogBoxMessageLine1 = "Vous n'avez pas enregistré vos modifications.";
  private dialogBoxMessageLine2 = 'Quitter quand-même ce formulaire ?';

  public canDeactivate(component: SavedChangeFormComponent): Observable<boolean> {
    if (!component.canDeactivate()) {
      const dialogRef = this._dialogBoxService.promptForAction({
        messageLine1: this.dialogBoxMessageLine1,
        onAccept: () => {},
        onDecline: () => {},
        messageLine2: this.dialogBoxMessageLine2,
      });

      return dialogRef.afterClosed().pipe(
        // map the dialog result to a true/false indicating whether
        // the route can deactivate
        map((result) => {
          return result === true;
        }),
      );
    }

    return of(true);
  }
}
